<script>

const moment = require('moment');

export default {

    name: 'item-owner',
    props: [ 'item' ],
    data() {
        return {
            data: {}
        }
    },
    computed: {
        label() { return `${ this.item.first_name } ${ this.item.last_name }` },
    },
    methods: {},
    created() {},

}

</script>

<template>

    <div>{{ label }}</div>

</template>


